<!--
 * @Author: zhangxx 2425792130@qq.com
 * @Date: 2025-07-29 19:12:26
 * @LastEditors: zhangxx 2425792130@qq.com
 * @LastEditTime: 2025-07-31 19:16:48
 * @FilePath: \original-pc-toB-bookstores-red(ToB书城PC版红色)\src\views\readHome\readingHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="hotRead">
        <div class="topbg">
          <el-breadcrumb separator="/">
             <el-breadcrumb-item :to="{ path: '/read/readIndex' }">首页</el-breadcrumb-item>
             <el-breadcrumb-item>TOP热读</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <h3 class="bigTitle">TOP热读</h3>
        <div class="book">
                    <div class="book-item" v-for="item in 5" :key="item">
                        <div class="lefts">
                            <img src="../../assets/readimg/newBook.png" alt="">
                        </div>
                        <div class="right">
                            <h4 class="title">漫步华尔街标题</h4>
                            <p>作者姓名</p>
                            <div class="desc">
                                描述部分多余的用省略号表示
                            </div>
                        </div>
                    </div>
                </div>
    </div>
</template>

<script>
export default {
    name: 'hotRead',
    components: {
    },
    data() {
        return {
            
        }
    },
   
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
.hotRead{
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
}
.topbg {
    // width: 80%;
    margin: 20px auto;
}
.bigTitle {
    // width: 80%;
    margin: 20px auto;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-top: 45px;
}
.book {
    // width: 80%;
    margin: 10px auto;
            display: flex;
            margin-top: 30px;
            flex-wrap: wrap; // 允许换行
            gap: 22px;
            .book-item {
                display: flex;
                width: 32%;
                margin-bottom: 30px;
                background-color: #fff;
                border-radius: 10px;

                .lefts {
                    width: 200px;
                    
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 10px; // 圆角效果
                    }
                }
                .right {
                    padding: 15px 17px;
                    .title {
                        margin-bottom: 15px;
                        box-sizing: border-box;
                    }
                    .desc {
                        margin-top: 8px;
                        box-sizing: border-box;
                        background-color: #f7f7f7;
                        height: 110px;
                        padding: 10px;
                    }
                }
            }
        }
</style>